import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import Switch from "react-switch";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { Col } from "react-bootstrap";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";

export const OnlineEventsSubscription = (props) => {
  let history = useHistory();
  const [state, setState] = useState({
    link_code_different: true,
    link_code_same: false,
    casualDiningOnlineEventsYoutube: false,
    casualDiningOnlineEventsInstagram: false,
    casualDiningOnlineEventsFacebook: false,
    casualDiningOnlineEventsLinkdin: false,
    casualDiningOnlineEventsOthers: false,
    casualDiningOnlineEventsYoutubeArr: [],
    casualDiningOnlineEventsInstagramArr: [],
    casualDiningOnlineEventsFacebookArr: [],
    casualDiningOnlineEventsLinkdinArr: [],
    casualDiningOnlineEventsOthersArr: [],
    errors: {},
  });

  const onFocusOutLink = (e) => {
    const { errors } = state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      delete errors[e.target.name];
    }
    setState({
      ...state,
      errors: errors,
      error: Object.keys(errors).length > 0 ? true : false,
      actionButton: true,
    });
  };

  const casualDiningInsideOfflineEventHandler = (type) => (e) => {
    if (type === "eventLinkCodes") {
      setState({
        ...state,
        link_code_different: !state.link_code_different,
        link_code_same: !state.link_code_same,
        casualDiningOnlineEventsYoutube: false,
        casualDiningOnlineEventsInstagram: false,
        casualDiningOnlineEventsFacebook: false,
        casualDiningOnlineEventsLinkdin: false,
        casualDiningOnlineEventsOthers: false,
        casualDiningOnlineEventsYoutubeArr: [],
        casualDiningOnlineEventsInstagramArr: [],
        casualDiningOnlineEventsFacebookArr: [],
        casualDiningOnlineEventsLinkdinArr: [],
        casualDiningOnlineEventsOthersArr: [],
      });
    } else if (type === "eventSameLinkCode") {
      setState({
        ...state,
        link_code_different: !state.link_code_different,
        link_code_same: !state.link_code_same,
      });
    } else if (type === "eventYoutubeLink") {
      setState({
        ...state,
        casualDiningOnlineEventsYoutube: !state.casualDiningOnlineEventsYoutube,
        casualDiningOnlineEventsYoutubeArr: [
          {
            url: "",
            business_channel: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventInstagramLink") {
      setState({
        ...state,
        casualDiningOnlineEventsInstagram:
          !state.casualDiningOnlineEventsInstagram,
        casualDiningOnlineEventsInstagramArr: [
          {
            url: "",
            business_channel: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventFacebookLink") {
      setState({
        ...state,
        casualDiningOnlineEventsFacebook:
          !state.casualDiningOnlineEventsFacebook,
        casualDiningOnlineEventsFacebookArr: [
          {
            url: "",
            business_channel: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventLinkdinLink") {
      setState({
        ...state,
        casualDiningOnlineEventsLinkdin: !state.casualDiningOnlineEventsLinkdin,
        casualDiningOnlineEventsLinkdinArr: [
          {
            url: "",
            business_channel: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventOthersLink") {
      setState({
        ...state,
        casualDiningOnlineEventsOthers: !state.casualDiningOnlineEventsOthers,
        casualDiningOnlineEventsOthersArr: [
          {
            url: "",
            business_channel: "",
            code: "",
          },
        ],
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Youtube Handlers
   ******************************************/
  const onAddYoutubeHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsYoutubeArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].business_channel === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.business_channel = `*Fields can’t be blank. Please enter your business_channel`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        business_channel: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsYoutubeArr: linkDesc,
      });
    }
  };

  const onYoutubeChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsYoutubeArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].business_channel = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsYoutubeArr: linkDesc,
    });
  };

  const onYoutubeDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsYoutubeArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsYoutubeArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Instagram Handlers
   ******************************************/
  const onAddInstagramHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsInstagramArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].business_channel === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.business_channel = `*Fields can’t be blank. Please enter your business_channel`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        business_channel: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsInstagramArr: linkDesc,
      });
    }
  };

  const onInstagramChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsInstagramArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].business_channel = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsInstagramArr: linkDesc,
    });
  };

  const onInstagramDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsInstagramArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsInstagramArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Facebook Handlers
   ******************************************/
  const onAddFacebookHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsFacebookArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].business_channel === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.business_channel = `*Fields can’t be blank. Please enter your business_channel`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        business_channel: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsFacebookArr: linkDesc,
      });
    }
  };

  const onFacebookChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsFacebookArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].business_channel = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsFacebookArr: linkDesc,
    });
  };

  const onFacebookDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsFacebookArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsFacebookArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Linkedin Handlers
   ******************************************/
  const onAddLinkdinHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsLinkdinArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].business_channel === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.business_channel = `*Fields can’t be blank. Please enter your business_channel`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        business_channel: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsLinkdinArr: linkDesc,
      });
    }
  };

  const onLinkdinChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsLinkdinArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].business_channel = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsLinkdinArr: linkDesc,
    });
  };

  const onLinkdinDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsLinkdinArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsLinkdinArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Others Handlers
   ******************************************/
  const onAddOthersHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsOthersArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].business_channel === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.business_channel = `*Fields can’t be blank. Please enter your business_channel`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        business_channel: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsOthersArr: linkDesc,
      });
    }
  };

  const onOthersChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsOthersArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].business_channel = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsOthersArr: linkDesc,
    });
  };

  const onOthersDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsOthersArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsOthersArr: linkDesc });
    }
  };

  const onSubmitHandler = (e) => {
    let values = {
      value:
        state.link_code_different === false &&
        state.link_code_same === false &&
        state.casualDiningOnlineEventsYoutube === false &&
        state.casualDiningOnlineEventsInstagram === false &&
        state.casualDiningOnlineEventsFacebook === false &&
        state.casualDiningOnlineEventsLinkdin === false &&
        state.casualDiningOnlineEventsOthers === false
          ? false
          : true,
      link_code_different: state.link_code_different,
      link_code_same: state.link_code_same,
      youtube: {
        value: state.casualDiningOnlineEventsYoutube,
        sub_values: state.casualDiningOnlineEventsYoutubeArr,
      },
      instagram: {
        value: state.casualDiningOnlineEventsInstagram,
        sub_values: state.casualDiningOnlineEventsInstagramArr,
      },
      facebook: {
        value: state.casualDiningOnlineEventsFacebook,
        sub_values: state.casualDiningOnlineEventsFacebookArr,
      },
      linkedin: {
        value: state.casualDiningOnlineEventsLinkdin,
        sub_values: state.casualDiningOnlineEventsLinkdinArr,
      },
      other: {
        value: state.casualDiningOnlineEventsOthers,
        sub_values: state.casualDiningOnlineEventsOthersArr,
      },
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    formData.multi_service_business_status.event_management.online_event =
      values;
    // console.log(formData);
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Event subscription add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/multi-service/events");
  };

  useEffect(() => {
    if (
      props.subscriptionData &&
      props.subscriptionData.link_code_different === undefined &&
      props.subscriptionData.link_code_same === undefined &&
      props.subscriptionData.youtube.value === undefined &&
      props.subscriptionData.instagram.value === undefined &&
      props.subscriptionData.facebook.value === undefined &&
      props.subscriptionData.linkedin.value === undefined &&
      props.subscriptionData.other.value === undefined &&
      props.subscriptionData.youtube.sub_values === undefined &&
      props.subscriptionData.instagram.sub_values === undefined &&
      props.subscriptionData.facebook.sub_values === undefined &&
      props.subscriptionData.linkedin.sub_values === undefined &&
      props.subscriptionData.other.sub_values === undefined
    ) {
      setState({
        ...state,
        link_code_same: state.link_code_same,
        link_code_different: state.link_code_different,
        casualDiningOnlineEventsYoutube: state.casualDiningOnlineEventsYoutube,
        casualDiningOnlineEventsInstagram:
          state.casualDiningOnlineEventsInstagram,
        casualDiningOnlineEventsFacebook:
          state.casualDiningOnlineEventsFacebook,
        casualDiningOnlineEventsLinkdin: state.casualDiningOnlineEventsLinkdin,
        casualDiningOnlineEventsOthers: state.casualDiningOnlineEventsOthers,
        casualDiningOnlineEventsYoutubeArr:
          state.casualDiningOnlineEventsYoutubeArr,
        casualDiningOnlineEventsInstagramArr:
          state.casualDiningOnlineEventsInstagramArr,
        casualDiningOnlineEventsFacebookArr:
          state.casualDiningOnlineEventsFacebookArr,
        casualDiningOnlineEventsLinkdinArr:
          state.casualDiningOnlineEventsLinkdinArr,
        casualDiningOnlineEventsOthersArr:
          state.casualDiningOnlineEventsOthersArr,
      });
    } else {
      setState({
        ...state,
        link_code_different:
          props.subscriptionData && props.subscriptionData.link_code_different,
        link_code_same:
          props.subscriptionData && props.subscriptionData.link_code_same,
        casualDiningOnlineEventsYoutube:
          props.subscriptionData && props.subscriptionData.youtube.value,
        casualDiningOnlineEventsInstagram:
          props.subscriptionData && props.subscriptionData.instagram.value,
        casualDiningOnlineEventsFacebook:
          props.subscriptionData && props.subscriptionData.facebook.value,
        casualDiningOnlineEventsLinkdin:
          props.subscriptionData && props.subscriptionData.linkedin.value,
        casualDiningOnlineEventsOthers:
          props.subscriptionData && props.subscriptionData.other.value,
        casualDiningOnlineEventsYoutubeArr:
          props.subscriptionData && props.subscriptionData.youtube.sub_values,
        casualDiningOnlineEventsInstagramArr:
          props.subscriptionData && props.subscriptionData.instagram.sub_values,
        casualDiningOnlineEventsFacebookArr:
          props.subscriptionData && props.subscriptionData.facebook.sub_values,
        casualDiningOnlineEventsLinkdinArr:
          props.subscriptionData && props.subscriptionData.linkedin.sub_values,
        casualDiningOnlineEventsOthersArr:
          props.subscriptionData && props.subscriptionData.other.sub_values,
      });
    }
  }, [props.subscriptionData]);

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {console.log(state)}
        <div className="container-fluid">
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
            >
              <Media query="(min-width: 992px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={"/multi-service/events"}
                    notDisplaProgressBar={true}
                  />
                </div>
              </Media>

              <Media query="(max-width: 991px)">
                <MobileTopHeader link={true} onLink={"/multi-service/events"} />
              </Media>
              <div className="onboarding_process_screen-button-map inside-subscription-event-section">
                <div className="col-8 p-0">
                  <TopTextReusableComponent
                    headingText="Online Event Management"
                    headingParagraph="(Note: Events are online and accept RSVP, you can set these links when creating an event on dashboard)"
                  />
                </div>
                <div className="inside-event-offline-online-text ">
                  <div className="row margin-between-toggler offers-events-screen-toggle mt-4">
                    <div className="col-8">
                      <div className="f16-700">
                        Links and Codes are different for each Event
                      </div>
                      <div className="f11-400 opacity5">
                        You can Enter your live streaming and code information
                        at the time of Event creation
                      </div>
                    </div>
                    <div className="col-4">
                      <Switch
                        checked={state.link_code_different}
                        onChange={casualDiningInsideOfflineEventHandler(
                          "eventLinkCodes"
                        )}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </div>
                  <div className="row p-0 margin-between-toggler offers-events-screen-toggle">
                    <div className="col-8">
                      <div className="f16-700">
                        Links and Codes are same for every Event
                      </div>
                    </div>
                    <div className="col-4">
                      <Switch
                        checked={state.link_code_same}
                        onChange={casualDiningInsideOfflineEventHandler(
                          "eventSameLinkCode"
                        )}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </div>
                </div>
                {state.link_code_same ? (
                  <React.Fragment>
                    <div className="row margin-between-toggler inside-event-offline-online-text">
                      <div className="col-8">
                        <div className="f14-500">Youtube</div>
                        <div className="f11-400 opacity5">
                          Enter your hyperlink and joining code information for
                          event below
                        </div>
                      </div>
                      <div className="col-4">
                        <Switch
                          checked={state.casualDiningOnlineEventsYoutube}
                          onChange={casualDiningInsideOfflineEventHandler(
                            "eventYoutubeLink"
                          )}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={16}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={10}
                          width={27}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                      </div>
                    </div>
                    {state.casualDiningOnlineEventsYoutube ? (
                      <React.Fragment>
                        {state.casualDiningOnlineEventsYoutubeArr.map(
                          (data, index) => (
                            <div
                              className="row inside-event-offline-online-text mb-5"
                              key={index}
                            >
                              <div className="col-12">
                                <div className="row mt-4">
                                  <Col md={7}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="url"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onYoutubeChangeHandler(
                                        "link",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.url}
                                      labelText="Stream URL*"
                                      errorText={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "*Fields can’t be blank. Please enter your Stream URL"
                                          : null
                                      }
                                      errorTrue={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                    <div className="f11-400 opacity5">
                                      Anyone using these links can watch the
                                      live stream, any violation is subject to
                                      review and flagging the account.
                                    </div>
                                  </Col>
                                  <Col md={5}>
                                    <NewInputText
                                      extraClass="mb-1 w-100"
                                      name="business_channel"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onYoutubeChangeHandler(
                                        "business",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.business_channel}
                                      labelText="Business Channel*"
                                      errorText={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "*Fields can’t be blank. Please enter your Business Channel"
                                          : null
                                      }
                                      errorTrue={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4">
                                  <Col md={3} className="pt-2 f14-500">
                                    Event Code If Any?
                                  </Col>
                                  <Col md={4}>
                                    <NewInputText
                                      extraClass="mb-1 mr-3 w-100"
                                      name="code"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onYoutubeChangeHandler(
                                        "code",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.code}
                                      labelText="Event Code*"
                                      errorText={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "*Fields can’t be blank. Please enter your Event Code"
                                          : null
                                      }
                                      errorTrue={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                  {state.casualDiningOnlineEventsYoutubeArr
                                    .length > 1 ? (
                                    <div className="col-2 restaurant_details_onboarding_minus_button align-items-start pt-2">
                                      <div>
                                        <AddButtonIconComponent
                                          buttonText="Delete"
                                          onClick={onYoutubeDeleteHandler(
                                            index
                                          )}
                                          fontIcon="fa fa-trash-o"
                                          colorCss="delete"
                                        />
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddYoutubeHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                        <hr />
                      </React.Fragment>
                    ) : null}

                    <div className="row margin-between-toggler inside-event-offline-online-text">
                      <div className="col-8">
                        <div className="f14-500">Instagram</div>
                        <div className="f11-400 opacity5">
                          Enter your hyperlink and joining code information for
                          event below
                        </div>
                      </div>
                      <div className="col-4">
                        <Switch
                          checked={state.casualDiningOnlineEventsInstagram}
                          onChange={casualDiningInsideOfflineEventHandler(
                            "eventInstagramLink"
                          )}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={16}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={10}
                          width={27}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                      </div>
                    </div>
                    {state.casualDiningOnlineEventsInstagram ? (
                      <React.Fragment>
                        {state.casualDiningOnlineEventsInstagramArr.map(
                          (data, index) => (
                            <div
                              className="row inside-event-offline-online-text mb-5"
                              key={index}
                            >
                              <div className="col-12">
                                <div className="row mt-4">
                                  <Col md={7}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="url"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onInstagramChangeHandler(
                                        "link",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.url}
                                      labelText="Stream URL*"
                                      errorText={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "*Fields can’t be blank. Please enter your Stream URL"
                                          : null
                                      }
                                      errorTrue={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                    <div className="f11-400 opacity5">
                                      Anyone using these links can watch the
                                      live stream, any violation is subject to
                                      review and flagging the account.
                                    </div>
                                  </Col>
                                  <Col md={5}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="business_channel"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onInstagramChangeHandler(
                                        "business",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.business_channel}
                                      labelText="Business Channel*"
                                      errorText={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "*Fields can’t be blank. Please enter your Business Channel"
                                          : null
                                      }
                                      errorTrue={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>
                                <div className="row mt-4">
                                  <Col md={3} className="pt-2 f14-500">
                                    Event Code If Any?
                                  </Col>
                                  <Col md={4}>
                                    <NewInputText
                                      extraClass="mb-1 mr-3"
                                      name="code"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onInstagramChangeHandler(
                                        "code",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.code}
                                      labelText="Event Code*"
                                      errorText={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "*Fields can’t be blank. Please enter your Event Code"
                                          : null
                                      }
                                      errorTrue={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>
                              </div>
                              {state.casualDiningOnlineEventsInstagramArr
                                .length > 1 ? (
                                <div className="col-2 restaurant_details_onboarding_minus_button">
                                  <div>
                                    <AddButtonIconComponent
                                      buttonText="Delete"
                                      onClick={onInstagramDeleteHandler(index)}
                                      fontIcon="fa fa-trash-o"
                                      colorCss="delete"
                                    />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          )
                        )}
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddInstagramHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                        <hr />
                      </React.Fragment>
                    ) : null}

                    <div className="row margin-between-toggler inside-event-offline-online-text">
                      <div className="col-8">
                        <div className="f14-500">Facebook</div>
                        <div className="f11-400 opacity5">
                          Enter your hyperlink and joining code information for
                          event below
                        </div>
                      </div>
                      <div className="col-4">
                        <Switch
                          checked={state.casualDiningOnlineEventsFacebook}
                          onChange={casualDiningInsideOfflineEventHandler(
                            "eventFacebookLink"
                          )}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={16}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={10}
                          width={27}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                      </div>
                    </div>
                    {state.casualDiningOnlineEventsFacebook ? (
                      <React.Fragment>
                        {state.casualDiningOnlineEventsFacebookArr.map(
                          (data, index) => (
                            <div
                              className="row inside-event-offline-online-text mb-5"
                              key={index}
                            >
                              <div className="col-12">
                                <div className="row mt-4">
                                  <Col md={7}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="url"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onFacebookChangeHandler(
                                        "link",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.url}
                                      labelText="Stream UR*"
                                      errorText={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "*Fields can’t be blank. Please enter your Stream URL"
                                          : null
                                      }
                                      errorTrue={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                    <div className="f11-400 opacity5">
                                      Anyone using these links can watch the
                                      live stream, any violation is subject to
                                      review and flagging the account.
                                    </div>
                                  </Col>
                                  <Col md={5}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="business_channel"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onFacebookChangeHandler(
                                        "business",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.business_channel}
                                      labelText="Business Channel*"
                                      errorText={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "*Fields can’t be blank. Please enter your Business Channel"
                                          : null
                                      }
                                      errorTrue={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>
                                <div className="row mt-4">
                                  <Col md={3} className="pt-2 f14-500">
                                    Event Code If Any?
                                  </Col>
                                  <Col md={4}>
                                    <NewInputText
                                      extraClass="mb-1 mr-3"
                                      name="code"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onFacebookChangeHandler(
                                        "code",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.code}
                                      labelText="Event Code*"
                                      errorText={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "*Fields can’t be blank. Please enter your Event Code"
                                          : null
                                      }
                                      errorTrue={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>
                              </div>
                              {state.casualDiningOnlineEventsFacebookArr
                                .length > 1 ? (
                                <div className="col-2 restaurant_details_onboarding_minus_button">
                                  <div>
                                    <AddButtonIconComponent
                                      buttonText="Delete"
                                      onClick={onFacebookDeleteHandler(index)}
                                      fontIcon="fa fa-trash-o"
                                      colorCss="delete"
                                    />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          )
                        )}
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddFacebookHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                        <hr />
                      </React.Fragment>
                    ) : null}

                    <div className="row margin-between-toggler inside-event-offline-online-text">
                      <div className="col-8">
                        <div className="f14-500">Linkedin</div>
                        <div className="f11-400 opacity5">
                          Enter your hyperlink and joining code information for
                          event below
                        </div>
                      </div>
                      <div className="col-4">
                        <Switch
                          checked={state.casualDiningOnlineEventsLinkdin}
                          onChange={casualDiningInsideOfflineEventHandler(
                            "eventLinkdinLink"
                          )}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={16}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={10}
                          width={27}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                      </div>
                    </div>
                    {state.casualDiningOnlineEventsLinkdin ? (
                      <React.Fragment>
                        {state.casualDiningOnlineEventsLinkdinArr.map(
                          (data, index) => (
                            <div
                              className="row inside-event-offline-online-text mb-5"
                              key={index}
                            >
                              <div className="col-12">
                                <div className="row mt-4">
                                  <Col md={7}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="url"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onLinkdinChangeHandler(
                                        "link",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.url}
                                      labelText="Stream URL*"
                                      errorText={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "*Fields can’t be blank. Please enter your Stream URL"
                                          : null
                                      }
                                      errorTrue={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                    <div className="f11-400 opacity5">
                                      Anyone using these links can watch the
                                      live stream, any violation is subject to
                                      review and flagging the account.
                                    </div>
                                  </Col>
                                  <Col md={5}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="business_channel"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onLinkdinChangeHandler(
                                        "business",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.business_channel}
                                      labelText="Business Channel*"
                                      errorText={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "*Fields can’t be blank. Please enter your Business Channel"
                                          : null
                                      }
                                      errorTrue={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>

                                <div className="row mt-4">
                                  <Col md={3} className="pt-2 f14-500">
                                    Event Code If Any?
                                  </Col>
                                  <Col md={4}>
                                    <NewInputText
                                      extraClass="mb-1 mr-3"
                                      name="code"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onLinkdinChangeHandler(
                                        "code",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.code}
                                      labelText="Event Code*"
                                      errorText={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "*Fields can’t be blank. Please enter your Event Code"
                                          : null
                                      }
                                      errorTrue={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>
                              </div>
                              {state.casualDiningOnlineEventsLinkdinArr.length >
                              1 ? (
                                <div className="col-2 restaurant_details_onboarding_minus_button">
                                  <div>
                                    <AddButtonIconComponent
                                      buttonText="Delete"
                                      onClick={onLinkdinDeleteHandler(index)}
                                      fontIcon="fa fa-trash-o"
                                      colorCss="delete"
                                    />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          )
                        )}
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddLinkdinHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                        <hr />
                      </React.Fragment>
                    ) : null}

                    <div className="row margin-between-toggler inside-event-offline-online-text">
                      <div className="col-8">
                        <div className="f14-500">Others</div>
                        <div className="f11-400 opacity5">
                          Enter your hyperlink and joining code information for
                          event below
                        </div>
                      </div>
                      <div className="col-4">
                        <Switch
                          checked={state.casualDiningOnlineEventsOthers}
                          onChange={casualDiningInsideOfflineEventHandler(
                            "eventOthersLink"
                          )}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={16}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={10}
                          width={27}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                      </div>
                    </div>
                    {state.casualDiningOnlineEventsOthers ? (
                      <React.Fragment>
                        {state.casualDiningOnlineEventsOthersArr.map(
                          (data, index) => (
                            <div
                              className="row inside-event-offline-online-text mb-5"
                              key={index}
                            >
                              <div className="col-12">
                                <div className="row mt-4">
                                  <Col md={7}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="url"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onOthersChangeHandler(
                                        "link",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.url}
                                      labelText="Stream URL*"
                                      errorText={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "*Fields can’t be blank. Please enter your Stream URL"
                                          : null
                                      }
                                      errorTrue={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.url === "" &&
                                        state.errors.url ===
                                          "*Fields can’t be blank. Please enter your url"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                    <div className="f11-400 opacity5">
                                      Anyone using these links can watch the
                                      live stream, any violation is subject to
                                      review and flagging the account.
                                    </div>
                                  </Col>
                                  <Col md={5}>
                                    <NewInputText
                                      extraClass="mb-1"
                                      name="business_channel"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onOthersChangeHandler(
                                        "business",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.business_channel}
                                      labelText="Business Channel*"
                                      errorText={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "*Fields can’t be blank. Please enter your Business Channel"
                                          : null
                                      }
                                      errorTrue={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.business_channel === "" &&
                                        state.errors.business_channel ===
                                          "*Fields can’t be blank. Please enter your business_channel"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>
                                <div className="row mt-4">
                                  <Col md={3} className="pt-2 f14-500">
                                    Event Code If Any?
                                  </Col>
                                  <Col md={4}>
                                    <NewInputText
                                      extraClass="mb-1 mr-3"
                                      name="code"
                                      inputType="text"
                                      onFocusOut={onFocusOutLink}
                                      onChange={onOthersChangeHandler(
                                        "code",
                                        index
                                      )}
                                      maxLength="50"
                                      value={data.code}
                                      labelText="Event Code*"
                                      errorText={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "*Fields can’t be blank. Please enter your Event Code"
                                          : null
                                      }
                                      errorTrue={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? true
                                          : false
                                      }
                                      controlClass={
                                        data.code === "" &&
                                        state.errors.code ===
                                          "*Fields can’t be blank. Please enter your code"
                                          ? "outlined-error-helper-text"
                                          : "outlined-helperText "
                                      }
                                    />
                                  </Col>
                                </div>
                              </div>
                              {state.casualDiningOnlineEventsOthersArr.length >
                              1 ? (
                                <div className="col-2 restaurant_details_onboarding_minus_button">
                                  <div>
                                    <AddButtonIconComponent
                                      buttonText="Delete"
                                      onClick={onOthersDeleteHandler(index)}
                                      fontIcon="fa fa-trash-o"
                                      colorCss="delete"
                                    />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          )
                        )}
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddOthersHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                        <hr />
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ) : null}

                <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link="/multi-service/events"
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Done"
                    buttonType="button"
                    onClick={onSubmitHandler}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                // displayBarButton={true}
                displayHamburger={true}
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-02.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

OnlineEventsSubscription.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details
      .multi_service_business_status &&
    state.onboarding.onboard_subscription_details.multi_service_business_status
      .event_management &&
    state.onboarding.onboard_subscription_details.multi_service_business_status
      .event_management.online_event,
  allSubscriptionsData:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(OnlineEventsSubscription));
